<!-- eslint-disable max-len -->
<template>
  <div>
    <h4 v-if="useTitle">
      {{ (element && element.info) ?
      JSON.parse(element.info).title : formUi.name }}
    </h4>

    <div class="jCalendar container-calendar m__t--15">
      <vue-cal
        :events="events"
        :disable-views="disableViews"
        default-view="month"
        events-on-month-view="short"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-nested-ternary, max-len, no-console, no-unused-vars, no-eval, no-mixed-operators, no-underscore-dangle, no-param-reassign, no-plusplus */
import axios from 'axios';
import Vue from 'vue';
import VueCal from 'vue-cal';
import jwtDecode from 'jwt-decode';
import { mapState, mapActions } from 'vuex';
import jMixFilterV2 from '@/mixins/jMixFilterV2';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';

import 'vue-cal/dist/vuecal.css';

export default {
  components: {
    jLoadingTable,
    VueCal,
  },
  mixins: [jMixFilterV2],
  props: {
    element: {
      type: Object,
      default: () => {},
    },
    formData: {
      type: Object,
      default: () => {},
    },
    formUi: {
      type: Object,
      default: () => {},
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
    onWidget: {
      type: Boolean,
      default: false,
    },
    useTitle: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      popoverFilterShow: false,
      isMode: '',
      dataRecordForm: [],
      options_search: [],
      options_search_master: [],
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
      filterFunction: {},
      showServerTable: false,
      filterActice: false,
      filterSearchOptions: {},
      events: [],
      disableViews: ['years', 'year', 'weeks', 'days'],
    };
  },
  computed: {
    ...mapState('jStoreFormUi', ['data_record']),

    formDataId() {
      return this.formUi.form_data_id;
    },

    dataCalender() {
      return this.formUi.calendar_view;
    },

    dataDetail() {
      return this.formUi.detail_view;
    },
  },
  watch: {
  },
  created() {
    if (this.dataCalender) {
      this.isMode = this.formDataId ? 'form' : 'external_url';
      this.setListOptionSearching();

      if (this.formDataId) {
        setTimeout(() => {
          this.cekIsUseFilterFunction();
        }, 200);
      } else {
        this.getCalenderViewDataExternal();
      }
    }
  },
  methods: {
    ...mapActions('jStoreFormUi', ['actionGetRecordData', 'actionGetRecordDataV2', 'actionGetFunctionData']),

    getFilterDataSearchOptions() {
      if (this.options_search_master.length > 0) {
        this.filterActice = true;
        this.filterSearchOptions = {};
        this.options_search_master.forEach((e, index) => {
          const dataRef = `jFormSearch-${index}`;
          this.$refs[String(dataRef)][0].getData().then((res) => {
            let valueFilterSearch = null;
            let selectType = e.field_data_key;
            if (this.cekTypeData(selectType) === 'timestamp' && res.value.start_date && res.value.end_date) {
              const startOfDay = new Date(Date.parse(`${res.value.start_date} 00:00:00`)).getTime();
              const endOfDay = new Date(Date.parse(`${res.value.end_date} 23:59:59`)).getTime();
              valueFilterSearch = [startOfDay, endOfDay];
            } else if (this.cekTypeData(selectType) === 'object' && res.value) {
              selectType = `${e.field_data_key}.id`;
              valueFilterSearch = res.value !== 0 ? res.value : '';
            } else if (this.cekTypeData(selectType) === 'tags' && res.value) {
              selectType = `${e.field_data_key}.name`;
              valueFilterSearch = res.value.name;
            } else if (this.cekTypeData(selectType) === '[]tags' && res.value.length > 0) {
              selectType = `${e.field_data_key}.name`;
              valueFilterSearch = res.value.map(el => (el.name));
            } else if (this.cekTypeData(selectType) === 'person' && res.value) {
              selectType = `${e.field_data_key}.company_user_id`;
              valueFilterSearch = e.person.company_user_id;
            } else if (this.cekTypeData(selectType) === 'number' && res.value) {
              valueFilterSearch = Number(res.value);
            } else if (this.cekTypeData(selectType) === 'text' && res.value) {
              valueFilterSearch = res.value;
            }

            if ((this.cekTypeData(e.field_data_key) === 'timestamp' && res.value.start_date && res.value.end_date) ||
                (this.cekTypeData(e.field_data_key) === '[]tags' && res.value.length > 0) ||
                ((this.cekTypeData(e.field_data_key) === 'object' ||
                  this.cekTypeData(e.field_data_key) === 'tags' ||
                  this.cekTypeData(e.field_data_key) === 'person' ||
                  this.cekTypeData(e.field_data_key) === 'number' ||
                  this.cekTypeData(e.field_data_key) === 'text') && res.value)) {
              if (this.filterSearchOptions[selectType]) {
                if (typeof this.filterSearchOptions[selectType] === 'object') {
                  const valueArray = this.filterSearchOptions[selectType];
                  valueArray.push(valueFilterSearch);
                  this.filterSearchOptions[selectType] = valueArray;
                } else {
                  this.filterSearchOptions[selectType] = [this.filterSearchOptions[selectType], valueFilterSearch];
                }
              } else {
                this.filterSearchOptions[selectType] = valueFilterSearch;
              }
            }
          });
        });
      }
    },

    cekIsUseFilterFunction() {
      if (this.dataCalender && this.dataCalender.filter_function) {
        this.getParamByFunction();
      } else {
        this.getCalenderViewData();
      }
    },

    cekTypeData(key) {
      if (key === '') { return ''; }
      if (key === null) { return ''; }
      if (this.isMode === 'form') {
        const findType = this.formData.columns[key];
        return findType ? findType.type : '';
      }

      const dataColumn = this.formUi ?
        (this.formUi.data_source ?
          (this.formUi.data_source.external_url ? this.formUi.data_source.external_url.columns : null)
          : null)
        : null;
      const findType = dataColumn[key];
      return findType.type;
    },

    setListOptionSearching() {
      if (this.dataCalender.search_options_list && this.dataCalender.search_options_list.length > 0) {
        this.options_search_master = this.dataCalender.search_options_list.map((e) => { e.id = e.field_data_key; return e; });
      }
    },

    convertDateTime(data) {
      if (data) {
        const date = new Date(data);
        const years = date.getFullYear();
        const mounth = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const dates = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();

        const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
        const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();

        return `${years}-${mounth}-${dates} ${hours}:${minutes}`;
      }
      return null;
    },

    convertTime(data) {
      if (data) {
        const date = new Date(data);
        const hours = date.getHours();
        const minutes = date.getMinutes();
        return `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
      }
      return null;
    },

    cekIsRegex(key) {
      const dataKey = key && key.includes('__duplicate') ? key.replace('__duplicate', '') : key;
      if (!dataKey) { return ''; }
      if (this.isMode === 'form') {
        const findRegex = this.formData ? this.formData.columns[dataKey] : null;
        return findRegex ? findRegex.is_use_regex : false;
      }
      return false;
    },

    getParamByFunction() {
      const filterFunctionKeys = Object.keys(this.dataCalender.filter_function);
      const filterFunctionValues = Object.values(this.dataCalender.filter_function);
      const lengthFunction = filterFunctionValues.length;
      let lengthProgress = 0;
      if (lengthFunction > 0) {
        this.showServerTable = false;
        filterFunctionValues.forEach((e, index) => {
          this.actionGetFunctionData(e).then((res) => {
            this.filterFunction[filterFunctionKeys[index]] = res;
            lengthProgress++;
            if (lengthFunction === lengthProgress) {
              this.getCalenderViewData();
            }
          });
        });
      } else {
        this.getCalenderViewData();
      }
    },

    getCalenderViewData() {
      this.clearDataFilterV2();
      this.popoverFilterShow = false;
      this.dataRecordForm = [];
      let dataFilter = {};

      if (this.element && JSON.parse(this.element.info).filter_column) {
        let x;
        let keyFilter = '';
        const dataRecord = this.data_record;
        if (this.cekTypeData(JSON.parse(this.element.info).filter_column) === 'object') {
          keyFilter = `"${JSON.parse(this.element.info).filter_column}.id"`;
        } else {
          keyFilter = JSON.parse(this.element.info).filter_column;
        }
        dataFilter = eval(`x={ ${keyFilter}: dataRecord.${JSON.parse(this.element.info).filter_variable} }`);

        this.combineFilterV2('Setup', keyFilter, eval(`x=dataRecord.${JSON.parse(this.element.info).filter_variable}`));
      }

      const filterFunctionKeys = Object.keys(this.filterFunction);
      const filterFunctionValues = Object.values(this.filterFunction);

      filterFunctionKeys.forEach((e, index) => {
        dataFilter[e] = filterFunctionValues[index];
        this.combineFilterV2('Setup', e, filterFunctionValues[index]);
      });

      const filterSearchOptionsKeys = Object.keys(this.filterSearchOptions);
      const filterSearchOptionsValues = Object.values(this.filterSearchOptions);

      filterSearchOptionsKeys.forEach((e, index) => {
        dataFilter[e] = filterSearchOptionsValues[index];
        this.combineFilterV2('App', e, filterSearchOptionsValues[index]);
      });

      let x;
      // eslint-disable-next-line
      const _user = this.session.user;
      const filterKeys = Object.keys(this.dataCalender.filter);
      const filterValues = Object.values(this.dataCalender.filter);

      if (filterValues.length > 0) {
        filterValues.forEach((e, index) => {
          if (typeof e === 'object' && e.length > 0) {
            const valueMulti = [];
            e.forEach((v) => {
              if (v.includes('_user')) {
                valueMulti.push(eval(`x=${v}`));
              } else if (filterKeys[index].includes('.company_user_id')) {
                valueMulti.push(Number(v));
              } else if (v.includes('.today')) {
                const date = new Date();
                const startOfDay = new Date(Date.parse(`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} 00:00:00`)).getTime();
                const endOfDay = new Date(Date.parse(`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} 23:59:59`)).getTime();
                // eslint-disable-next-line
                valueMulti.push([startOfDay, endOfDay]);
              } else {
                // eslint-disable-next-line
                if (this.cekTypeData(filterKeys[index]) === 'number') {
                  valueMulti.push(Number(v));
                } else {
                  valueMulti.push(v.slice(1, -1));
                }
              }
            });
            dataFilter[filterKeys[index]] = valueMulti;
            this.combineFilterV2('Setup', filterKeys[index], valueMulti);
          } else {
            // eslint-disable-next-line
            if (e.includes('_user')) {
              dataFilter[filterKeys[index]] = eval(`x=${e}`);
              this.combineFilterV2('Setup', filterKeys[index], eval(`x=${e}`));
            } else if (filterKeys[index].includes('.company_user_id')) {
              dataFilter[filterKeys[index]] = Number(e);
              this.combineFilterV2('Setup', filterKeys[index], Number(e));
            } else if (e.includes('.today')) {
              const date = new Date();
              const startOfDay = new Date(Date.parse(`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} 00:00:00`)).getTime();
              const endOfDay = new Date(Date.parse(`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} 23:59:59`)).getTime();
              dataFilter[filterKeys[index]] = [startOfDay, endOfDay];
              this.combineFilterV2('Setup', filterKeys[index], [startOfDay, endOfDay]);
            } else {
              // eslint-disable-next-line
              if (this.cekTypeData(filterKeys[index]) === 'number') {
                dataFilter[filterKeys[index]] = Number(e);
                this.combineFilterV2('Setup', filterKeys[index], Number(e));
              } else {
                dataFilter[filterKeys[index]] = e.slice(1, -1);
                this.combineFilterV2('Setup', filterKeys[index], e.slice(1, -1));
              }
            }
          }
        });
      }

      const param = {
        form_data_id: this.formDataId,
        page: 1,
        limit: 1000000000,
        filter_app: this.setFilterAppV2(this.dataCalender.filter_operator),
        filter_setup: this.setFilterSetupV2(this.dataCalender.filter_operator),
        filter_setup_operator: this.dataCalender.filter_operator || 'and',
      };

      if (!this.onWidget) {
        param.page_id = Number(this.$route.params.pageId);
      }

      this.actionGetRecordDataV2(param).then((res) => {
        const column = this.dataCalender.column;
        this.dataRecordForm = res.data;
        this.events = res.data.filter(f => f[column.start_date_time] && f[column.end_date_time]).map((el) => {
          const data = {
            event_id: el.id,
            start: this.convertDateTime(el[column.start_date_time]),
            end: this.convertDateTime(el[column.end_date_time]),
            from: this.convertTime(el[column.start_date_time]),
            to: this.convertTime(el[column.end_date_time]),
            title: el[column.title],
            note: el[column.description],
            class: el[column.color] || 'default',
          };
          return data;
        });
      });
    },

    getCalenderViewDataExternal() {
      this.popoverFilterShow = false;
      this.dataRecordExternal = [];

      const dataList = this.formUi ?
        (this.formUi.data_source ?
          (this.formUi.data_source.external_url ? this.formUi.data_source.external_url.list : null)
          : null)
        : null;

      if (dataList) {
        const token = Vue.ls.get('Token');
        const method = dataList.method.toLowerCase();

        let url = '';
        if (method === 'get') {
          const queryParams = Object.keys(dataList.query_params);
          const queryParamsValue = Object.values(dataList.query_params);
          // eslint-disable-next-line
          const _queryType = this.select_type ? dataList.variables[this.select_type] : '';
          // eslint-disable-next-line
          const _query = this.filter_data || '';

          let urlParams = '';
          queryParams.forEach((e, index) => {
            let z;
            const value = eval(`z=${queryParamsValue[index]}`);
            const andMore = queryParams.length - 1 > index ? '&' : '';
            urlParams += `${e}=${value}${andMore}`;
          });

          url = `${dataList.url}?${urlParams}`;
          axios.get(url, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }).then((res) => {
            this.dataRecordExternal = res.data[dataList.source];
          });
        } else {
          let y;
          const params = eval(`y=${dataList.body}`);

          url = dataList.url;
          axios[method](url, params, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }).then((res) => {
            this.dataRecordExternal = res.data[dataList.source];
          });
        }
      }
    },
  },
};
</script>

<style lang="scss">
  .jTable .form-control {
    padding-left: 5px !important;
    width: inherit !important;
  }

  .jTable select.form-control {
    height: inherit !important;
  }

  .jSelectSingle.vue-treeselect .vue-treeselect__menu-container .vue-treeselect__menu .vue-treeselect__list .vue-treeselect__list-item .vue-treeselect__option .vue-treeselect__label-container .vue-treeselect__label {
    text-align: left !important;
    float: left !important;
  }

  .jTable .btn-import-form {
    height: 33px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/widget/widget-card/jCalenderViewWidget.vue